export default "/assets/images/decibels-graph-lg.627e604a9bb26bc7.svg";